<template>
 <b-container fluid>
  <h1 v-html="currentPublication.page_title "></h1>

  <span id="publication">
    <dl>
      <dt v-if="currentPublication.publication_type" >Publication Type</dt>
      <dd v-if="currentPublication.publication_type" >{{currentPublication.publication_type}}</dd>

      <dt v-if="currentPublication.authors_long_listing" >Authors</dt>
      <dd v-if="currentPublication.authors_long_listing" >
        {{Object.keys(currentPublication.authors_long_listing)
            .map(function (z) {
              return currentPublication.authors_long_listing[z];
            })
            .join("; ") }}
      </dd>

      <dt v-if="currentPublication.journal_name" >Journal Name</dt>
      <dd v-if="currentPublication.journal_name" >{{currentPublication.journal_name}}</dd>

      <dt v-if="currentPublication.year" >Year</dt>
      <dd v-if="currentPublication.year" >{{currentPublication.year}}</dd>

      <dt v-if="currentPublication.url" >URL</dt>
      <dd v-if="currentPublication.url" >
        <BLink :href="currentPublication.url">{{currentPublication.url}}</BLink>
      </dd>

      <dt v-if="currentPublication.abstract" >Abstract</dt>
      <dd v-if="currentPublication.abstract" >{{currentPublication.abstract}}</dd>

      <dt v-if="currentPublication.links" >Links</dt>
      <dd v-if="currentPublication.links" >
        <ul v-for="link in currentPublication.links">
          <li>
            <BLink :href="link.url">{{link.name}}</BLink>
          </li>
        </ul>
      </dd>

    </dl>
  </span>
 </b-container>
</template>

<script>
import authMixins from '@/components/app/authMixins'
import { publications } from '@/init/data/publications'
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

export default {

  name: 'Publication',
  
  mixins: [ authMixins ],

  data () {
    return {
      publications: publications,
      currentPublication: publications[0],
    }
  },

  mounted(){
    const route=useRoute();
    this.updatecurrentPublication(route.params.publication_url);
  },

  watch: {

    $route: {
      handler(to, from) {
        // react to the route change if there is a publication_diretory parameter passed 
        if (to.params.publication_url) {
          var publicationIndex = this.returnMatchingpublicationIndex(to.params.publication_url)

          if (publicationIndex === null) {
            const router =useRouter()
            router.push('/missions/agage/404')
          } else {
            this.updatecurrentPublication(to.params.publication_url);
          }
        }
       },
      deep: true
    },


  },

  methods: {

    updatecurrentPublication(publication_url) {
      var publicationIndex = this.returnMatchingpublicationIndex(publication_url)

      if (publicationIndex !== null) {  
        this.currentPublication = this.publications[publicationIndex];
      } else {
        const router =useRouter()
        router.push('/missions/agage/404')
      }
    },

    returnMatchingpublicationIndex(publication_url) {
      // when given the publication_url, find the index for the 
      // publication that matches that publication_url
      var publicationIndex = null;
      var find_this_url = encodeURIComponent(publication_url);

      // handle special characters that encodeURIComponent does not handle
      find_this_url = find_this_url.replaceAll('(', '%28');
      find_this_url = find_this_url.replaceAll(')', '%29');
      find_this_url = find_this_url.replaceAll(',', '%2C');
      find_this_url = find_this_url.replaceAll(' ', '%20');
      find_this_url = find_this_url.replaceAll('\'', '%27');

      for (var i=0; i < this.publications.length; i++){
        // todo: encode
        if( this.publications[i].page_url == find_this_url){
          publicationIndex = i;
          break;
        }
      }
      return publicationIndex;
    },

  },

}
</script>

<style >
  h1, h2, h3, dt {
    color: #4D833A !important;
  }

  #publication a[href^="http"]::after,
  #publication a[href^="https://"]::after
  {
    width: 12px;
    height: 12px;
    margin-left: 4px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    display: inline-block;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' viewBox='0 0 16 16'%3E%3Cpath fill-rule='evenodd' d='M8.636 3.5a.5.5 0 0 0-.5-.5H1.5A1.5 1.5 0 0 0 0 4.5v10A1.5 1.5 0 0 0 1.5 16h10a1.5 1.5 0 0 0 1.5-1.5V7.864a.5.5 0 0 0-1 0V14.5a.5.5 0 0 1-.5.5h-10a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 .5-.5h6.636a.5.5 0 0 0 .5-.5z'/%3E%3Cpath fill-rule='evenodd' d='M16 .5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0 0 1h3.793L6.146 9.146a.5.5 0 1 0 .708.708L15 1.707V5.5a.5.5 0 0 0 1 0v-5z'/%3E%3C/svg%3E");
    content: "";
  }
</style>
